import { format } from "date-fns";
import { enUS } from "date-fns/locale";

export const FormateDate = (date) => {
    return format(new Date(date), "do MMM yyyy", { locale: enUS });

}

export const formatDateTime = (date) => {
    return format(new Date(date), "do MMM yyyy, hh:mm a");
  };
  